import React, { useContext } from 'react';
import { DateSelect } from "../../DateSelect";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import * as ColorFunctions from "../../../lib/styles/ColorFunctions";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../MonthView.styles";
import { themeConfig } from "../config";
import * as CDS from "../CalendarDateShape";
export function MonthView(props) {
  var _cx;

  var theme = useContext(ThemeContext);
  var children = props.children,
      height = props.height,
      isFirstInYear = props.isFirstInYear,
      isLastInYear = props.isLastInYear,
      maxDate = props.maxDate,
      minDate = props.minDate,
      month = props.month,
      top = props.top,
      year = props.year,
      onMonthSelect = props.onMonthSelect,
      onYearSelect = props.onYearSelect,
      monthSelectRef = props.monthSelectRef,
      yearSelectRef = props.yearSelectRef;
  var isTopNegative = top <= 0;
  var isHeaderSticky = isTopNegative && height >= -top;
  var headerTop = isHeaderSticky ? Math.min(-top, height - themeConfig(theme).MONTH_TITLE_HEIGHT) : 0;
  var alpha = isHeaderSticky ? (height + top - themeConfig(theme).MONTH_TITLE_HEIGHT) / 10 : 1;
  var borderBottomColor = ColorFunctions.fade(theme.calendarMonthTitleBorderBottomColor, alpha);
  var isYearVisible = isFirstInYear || isHeaderSticky;
  var yearTop = isHeaderSticky && !isLastInYear ? -headerTop - top : 0;
  var monthSelectDisabled = top > 40 || headerTop < 0 || headerTop >= height - themeConfig(theme).MONTH_TITLE_HEIGHT;
  var yearSelectDisabled = top > 40 || isLastInYear && top < -height + themeConfig(theme).MONTH_TITLE_HEIGHT;

  var getMinMonth = function getMinMonth(value) {
    var min = 0;

    for (var i = 0; i < 12; ++i) {
      if (minDate && CDS.isGreaterOrEqual({
        date: 31,
        month: i,
        year: value
      }, minDate)) {
        min = i;
        break;
      }
    }

    return min;
  };

  var getMaxMonth = function getMaxMonth(value) {
    var max = 11;

    for (var i = 11; i >= 0; --i) {
      if (maxDate && CDS.isLessOrEqual({
        date: 1,
        month: i,
        year: value
      }, maxDate)) {
        max = i;
        break;
      }
    }

    return max;
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-tid": "MonthView__month",
    className: styles.month(theme),
    style: {
      top: top
    },
    key: month + '-' + year
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      top: headerTop
    },
    className: cx((_cx = {}, _cx[styles.header()] = true, _cx[styles.headerSticky(theme)] = isHeaderSticky, _cx))
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderBottomColor: borderBottomColor
    },
    className: styles.monthTitle(theme)
  }, /*#__PURE__*/React.createElement("div", {
    "data-tid": "MonthView__headerMonth",
    className: styles.headerMonth(theme)
  }, /*#__PURE__*/React.createElement(DateSelect, {
    disabled: monthSelectDisabled,
    width: 85,
    type: "month",
    value: month,
    onValueChange: onMonthSelect,
    ref: !monthSelectDisabled ? monthSelectRef : undefined,
    minValue: getMinMonth(year),
    maxValue: getMaxMonth(year)
  })), isYearVisible && /*#__PURE__*/React.createElement("div", {
    "data-tid": "MonthView__headerYear",
    className: styles.headerYear(theme),
    style: {
      top: yearTop
    }
  }, /*#__PURE__*/React.createElement(DateSelect, {
    disabled: yearSelectDisabled,
    width: 50,
    type: "year",
    value: year,
    minValue: minDate ? minDate.year : undefined,
    maxValue: maxDate ? maxDate.year : undefined,
    onValueChange: onYearSelect,
    ref: !yearSelectDisabled ? yearSelectRef : undefined
  })))), children);
}